/*eslint-disable*/
import easydropdown from 'easydropdown'
export default el => {
	setTimeout(() => {
		let sel = document.querySelector('.size-guide.popup .easy-drop-mobile select')

		if (sel) {
			let edd = easydropdown(sel, {
				behavior: {
					useNativeUiOnMobile: false,
					showPlaceholderWhenOpen: true,
					liveUpdates: true,
				},
				classNames: {
					rootOpenBelow: true
				},
				callbacks: {
					onSelect: value => {
						$(`.easy-drop-mobile .edd-body .edd-option`).unbind('click.sameSelector touchstart.sameSelector')
						$(`.easy-drop-mobile .edd-body .edd-option[title="${value}"]`).bind('click.sameSelector touchstart.sameSelector', sameSelectionHandler)
						let $selected = $(`.easy-drop-mobile .edd-select option[value*="${value}"]`)
						$(`.size-guide_category_row .active`).removeClass('active')
						$(`.size-guide_table.active`).removeClass('active')
						$(`.size-guide_category_header_item.header_item${$selected.data('value')}`).parent().addClass('active')
						$(`.size-guide_table_container${$selected.data('value')}`).addClass('active')
						let placeholder = $(`.easy-drop-mobile .edd-select`).find('option').eq(0)
						setTimeout(() => $(`.easy-drop-mobile .edd-value`).text(placeholder.data('value')), 1000)
					},
				}
			})
		}
	}, 1500)

	const sameSelectionHandler = e => {
		let placeholder = $(`.easy-drop-mobile .edd-select`).find('option').eq(0)
		setTimeout(() => $(`.easy-drop-mobile .edd-value`).text(placeholder.data('value')), 1000)
	}
}




// WEBPACK FOOTER //
// ./src/scripts/components/mobile-size-guide-dropdown.js